import { PatientOrderStatus } from '../PatientDashboard/Patient.model'

/**
 * Past orders that have been placed but not yet shipped. Service Cloud allows
 * one order in progress per patient, so while one exists a resupply cannot
 * start: Oracle hands back that same order, and checkout would book it again
 * (CLOS-14645).
 */
const ORDER_IN_PROGRESS_STATUSES = new Set([
  'on hold',
  'processing',
  'awaiting shipping',
  'under medical review',
  'under review',
  'health authority review',
  'medical review deferred'
])

const normalise = (status?: string | null): string =>
  (status ?? '').replace(/_/g, ' ').trim().toLowerCase()

/**
 * True when the patient is shown as ready for resupply while a placed order is
 * still in progress: Oracle works that status out from shipments and does not
 * look at open orders.
 */
export const hasResupplyBlockingOrder = (
  patientOrderStatus: PatientOrderStatus,
  pastOrders?: { orderStatus?: string | null }[] | null
): boolean =>
  patientOrderStatus === PatientOrderStatus.ReadyForResupply &&
  (pastOrders ?? []).some((order) =>
    ORDER_IN_PROGRESS_STATUSES.has(normalise(order.orderStatus))
  )
